/**
 * Internal dependencies
 */
jQuery(document).ready(function () {
	console.log('DOMContentLoaded');
	jQuery('.js-autocomplete-codepostal').each(function () {
		jQuery(this).val('');
		jQuery(this).parent().children('')
		jQuery(this).autocomplete({
			source: function( request, response ) {

				jQuery.ajax({
					type: 'POST',
					url: abcos_plugin_vars.ajax_url,
					data: {
						action: "action_find_us",
						nonce: abcos_plugin_vars.ajax_nonce,
						term: request.term
					},
					success: function(data) {
						response( data );
					}
				});
			},
			delay: 500,
			minLength: 2,
			classes: {
				"ui-autocomplete": "ui-autocomplete ui-autocomplete-codepostal"
			},
			select: function (event, ui) {
				jQuery(this).parent().children("input[name=postal_code]").val( ui.item.postal_code);
			},
			close: function (event, ui) {

			}
		});
	});
	jQuery('.find_us_submit').on('click', function(event){
		let postal_code = jQuery(this).parent().children("input[name=postal_code]").val();
		if(postal_code===''){
			return false;
		}else{
			return true;
		}
	});
});
